<template>
  <v-layout row justify-center align-start>
    <v-card class="playables-container" xs6
            v-infinite-scroll="loadMore"
            infinite-scroll-disabled="isAutoscrollDisabled"
            infinite-scroll-distance="300">
      <v-toolbar card>
        <v-layout row wrap>
          <v-layout class="filters-container" row no-wrap>
            <v-select
                  :items="dropdownProjects"
                  item-text="text"
                  item-value="value"
                  v-model="project"
                  label="Проект"
                  hide-selected
                  hide-details
            ></v-select>
            <v-select
                    :items="dropdownFilterBy"
                    v-model="sortBy"
                    item-text="text"
                    item-value="value"
                    label="Сортировать по"
                    hide-details
            ></v-select>
          </v-layout>
          <v-spacer></v-spacer>
          <v-btn icon @click="search = !search">
            <v-icon :color="search ? 'green' : ''">search</v-icon>
          </v-btn>
          <v-btn icon @click="firstFetchPlayables">
            <v-icon>refresh</v-icon>
          </v-btn>
        </v-layout>
      </v-toolbar>
      <v-toolbar card v-if="search">
        <form class="full-width">
          <v-text-field v-model="searchName" label="Поиск"></v-text-field>
        </form>
      </v-toolbar>
      <playables-list v-if="hasPlayables" :playables="playables"/>
      <v-layout justify-center align-center class="pb-4 pt-4" v-else>
        <span>По текущему запросу ничего не найдено</span>
      </v-layout>
      <v-layout justify-center align-center class="pb-4 pt-4" v-if="isPlayablesLoading">
        <v-progress-circular :indeterminate="true"></v-progress-circular>
      </v-layout>
    </v-card>
  </v-layout>
</template>

<script>
import PlayablesList from '@/components/BasePlayablesList.vue'
import humanizationMixin from '@/mixins/humanization'
import { getProjects } from '../api/project'
import { mapActions, mapGetters, mapMutations } from 'vuex'
import { debounce } from 'lodash'

export default {
  components: {
    PlayablesList
  },
  mixins: [humanizationMixin],
  data () {
    return {
      search: false,
      projects: [],
      dropdownFilterBy: [
        {text: 'Названию', value: 'name'},
        {text: 'Дате ↑', value: 'date_asc'},
        {text: 'Дате ↓', value: 'date_desc'}
      ],
      stopAutoLoad: true,
      searchDebounced: null,
      loadModeDebounced: null,
    }
  },
  computed: {
    ...mapGetters([
      'playables', 'isPlayablesLoading',
      'currentProject', 'playablesNextPage',
      'sortByMethod'
    ]),
    searchName: {
      get () {
        return this.searchNameQuery
      },
      set (value) {
        this.setSearchName(value)
        this.searchDebounced()
      }
    },
    project: {
      get () {
        return this.currentProject
      },
      set (value) {
        this.setCurrentProject(value)
      }
    },
    sortBy: {
      get () {
        return this.sortByMethod
      },
      set (value) {
        return this.setSortByMethod(value)
      }
    },
    hasPlayables () {
      return this.playables ? this.playables.length > 0 : false
    },
    dropdownProjects () {
      return [
        { text: 'Все проекты', value: null, },
        ...this.projects.map(item => ({
          text: item.name,
          value: item.id,
        }))
      ];
    },
    isAutoscrollDisabled () {
      return this.stopAutoLoad || this.isPlayablesLoading;
    },
  },
  watch: {
    project (value) {
      this.firstFetchPlayables()
    },
    sortBy (value) {
      this.firstFetchPlayables()
    },
    search (value) { if (!value) this.searchName = null }
  },
  methods: {
    ...mapActions([
      'fetchPlayables', 'appendFetchPlayables'
    ]),
    ...mapMutations({
      setCurrentProject: 'SET_CURRENT_PROJECT',
      setSortByMethod: 'SET_SORT_BY_METHOD',
      setSearchName: 'SET_SEARCH_NAME'
    }),
    firstFetchPlayables () {
      this.fetchPlayables()
        .then(() => this.stopAutoLoad = false)
        .catch(error => {
          this.$eventHub.$emit('error-request-notify', error)
          this.stopAutoLoad = false
        })
    },
    handleSetCurrentProject (project) {
      this.setCurrentProject(project)
      this.firstFetchPlayables()
    },
    loadMore () {
      this.appendFetchPlayables()
        .then(() => {
          if (!this.playablesNextPage) this.stopAutoLoad = true
        })
        .catch(error => this.$eventHub.$emit('error-request-notify', error))
    },
    fetchProjects() {
      return getProjects()
        .then((response) => {
          this.projects = response.data;
        })
        .catch((error) => {
          this.$eventHub.$emit('error-request-notify', error);
        })
    },
  },
  mounted () {
    this.fetchProjects()
      .then(() => {
        this.firstFetchPlayables()
      })
  },
  created () {
    this.searchDebounced = debounce(() => {
      this.firstFetchPlayables()
    }, 500)

    this.loadMoreDebounced = debounce(() => {
      this.loadMore()
    }, 500);
  }
}
</script>

<style>
  .filters-container { max-width: 550px; }

  @media all and (max-width: 670px) {
    .filters-container {
      margin-top: 20px;
      align-items: center;
    }
    .v-toolbar__content {
      height: auto !important;
      align-items: center;
    }
  }
</style>
